import ShimmerTable from "./Table";

export default ShimmerTable;
